import { api } from "../api";

/**
 * findAllVehicleTypesListResponse - Function that finds on database all vehicles types as select list response   
 * /vehicles/types  
 * method GET 
 * @async-function
 */
const findAllVehicleTypesListResponse = async (token: string) => {
    const response = await api.get(
        `/vehicles/types`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default findAllVehicleTypesListResponse;